export default __webpack_public_path__ + "static/media/skyship11.cc441694.png";